import { LITE_TRADE_POSITION_SIDE, TLiteTradePositionSide } from '../../../../modules/LiteTrade/liteTradeConstants';
import type { ILiteTradeMarketItem } from '../../../../modules/LiteTrade/types/liteTradeReducer.t';

// если покупаем то берем ask, если продаем то bid
// withSpread = side === LITE_TRADE_POSITION_SIDE.BUY
export const getCurrentPriceFromMarket = (marketDataSymbol: ILiteTradeMarketItem, withSpread: boolean) => {
    return marketDataSymbol?.symbol ? marketDataSymbol[withSpread ? 'ask' : 'bid'] : undefined;
};

// @deprecated
export const getCurrentPrice = (marketDataSymbol: ILiteTradeMarketItem, side: TLiteTradePositionSide) =>
    marketDataSymbol?.symbol ? marketDataSymbol[side === LITE_TRADE_POSITION_SIDE.BUY ? 'ask' : 'bid'] : undefined;
// @deprecated
export const getCurrentPriceForPL = (marketDataSymbol: ILiteTradeMarketItem, side: TLiteTradePositionSide) =>
    marketDataSymbol?.symbol ? marketDataSymbol[side === LITE_TRADE_POSITION_SIDE.BUY ? 'bid' : 'ask'] : undefined;

export const switchSellerBuyer = (side: TLiteTradePositionSide): TLiteTradePositionSide =>
    side === LITE_TRADE_POSITION_SIDE.BUY ? LITE_TRADE_POSITION_SIDE.SELL : LITE_TRADE_POSITION_SIDE.BUY;

export const positiveOnly = (value: number) => (value < 0 ? 0 : value);